import { __assign } from "tslib";
import { ApiTypes, } from '../../sdk.types';
import { DOCUMENT_IMAGE_PLACEHOLDER, PRODUCT_IMAGE_PLACEHOLDER, } from './DocumentParser.constants';
import { flattenMarks } from './flattenMarks';
import { markHighlights } from './markHighlights';
var concatHighlights = function (input, highlights) { return (highlights ? flattenMarks(highlights === null || highlights === void 0 ? void 0 : highlights.join(' ')) : input); };
var DocumentParser = /** @class */ (function () {
    function DocumentParser(siteBaseUrl) {
        this.siteBaseUrl = siteBaseUrl;
    }
    DocumentParser.prototype.parseDefaultDocument = function (rawDocument) {
        var _a, _b, _c;
        return {
            description: concatHighlights((_a = rawDocument.description) !== null && _a !== void 0 ? _a : '', (_b = rawDocument._highlights) === null || _b === void 0 ? void 0 : _b.description),
            image: this.parseImage(rawDocument),
            relativeUrl: this.getRelativeUrl(rawDocument.url),
            title: markHighlights(rawDocument.title, (_c = rawDocument._highlights) === null || _c === void 0 ? void 0 : _c.title),
            url: this.parseUrl(rawDocument),
            id: rawDocument.id,
            documentType: rawDocument.documentType,
        };
    };
    DocumentParser.prototype.parseImage = function (document, emptyImage) {
        if (emptyImage === void 0) { emptyImage = DOCUMENT_IMAGE_PLACEHOLDER; }
        return document.documentImage ? document.documentImage : emptyImage;
    };
    DocumentParser.prototype.parseProductImage = function (document) {
        return this.parseImage(document, PRODUCT_IMAGE_PLACEHOLDER);
    };
    DocumentParser.prototype.parseUrl = function (document) {
        return "".concat(this.siteBaseUrl).concat(document.url);
    };
    DocumentParser.prototype.parseEventUrl = function (rawDocument) {
        return (rawDocument === null || rawDocument === void 0 ? void 0 : rawDocument.eventType) === 'EXTERNAL'
            ? rawDocument.url
            : this.parseUrl(rawDocument);
    };
    DocumentParser.prototype.getRelativeUrl = function (url) {
        return url === '' ? '/' : url;
    };
    DocumentParser.prototype.parse = function (rawDocument) {
        var _a, _b;
        var documentType = rawDocument.documentType;
        switch (documentType) {
            case ApiTypes.SearchDocumentType.Products:
                return __assign(__assign({}, this.parseDefaultDocument(rawDocument)), { price: rawDocument.discountedPrice, inStock: (_a = rawDocument.inStock) !== null && _a !== void 0 ? _a : true, currency: rawDocument.currency, image: this.parseProductImage(rawDocument) });
            case ApiTypes.SearchDocumentType.Pages:
                return __assign({}, this.parseDefaultDocument(rawDocument));
            case ApiTypes.SearchDocumentType.Blogs:
                return __assign({}, this.parseDefaultDocument(rawDocument));
            case ApiTypes.SearchDocumentType.Forums:
                return __assign(__assign({}, this.parseDefaultDocument(rawDocument)), { contentType: rawDocument.contentType, categoryTitle: rawDocument.categoryTitle, createdDate: rawDocument.createdDate, totalComments: rawDocument.totalComments, viewCount: rawDocument.viewCount, likeCount: rawDocument.likeCount, upvoteCount: rawDocument.upvoteCount, downvoteCount: rawDocument.downvoteCount, parentId: rawDocument.parentId });
            case ApiTypes.SearchDocumentType.Bookings:
                return __assign({}, this.parseDefaultDocument(rawDocument));
            case ApiTypes.SearchDocumentType.Events:
                return __assign(__assign({}, this.parseDefaultDocument(rawDocument)), { currency: rawDocument.currency, eventType: rawDocument.eventType, location: rawDocument.location &&
                        markHighlights(rawDocument.location, (_b = rawDocument._highlights) === null || _b === void 0 ? void 0 : _b.location), maxPrice: rawDocument.maxPrice, minPrice: rawDocument.minPrice, startDate: rawDocument.startDate, url: this.parseEventUrl(rawDocument) });
            case ApiTypes.SearchDocumentType.Programs:
                return __assign({}, this.parseDefaultDocument(rawDocument));
            case ApiTypes.SearchDocumentType.ProGallery:
                return __assign({}, this.parseDefaultDocument(rawDocument));
            default:
                // typechecking if we forgot any SearchDocumentType.
                // in runtime, function will still work if we got an unknown document type from the backend
                var unknownDocumentType = documentType;
                // eslint-disable-next-line no-console
                console.warn("You're trying to parse unknown document type - ".concat(rawDocument.documentType));
                return __assign(__assign({}, this.parseDefaultDocument(rawDocument)), { documentType: unknownDocumentType });
        }
    };
    return DocumentParser;
}());
export { DocumentParser };
//# sourceMappingURL=DocumentParser.js.map